<template>
  <div class="DriveByContainer">

    <div class="dbc" :style="{'animation-duration': duration + 'ms'}">
      <slot>
      </slot>
    </div>

  </div>
</template>

<script>

//import component from '@assets/components/component.vue'

export default {
  name: 'DriveByContainer',
  components: {
    //component
  },
  props: {
    duration: {type: Number, default: 1000}
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.DriveByContainer{
}

.dbc{
  text-align: center;
  animation: translate 1000ms linear infinite;
}

@-webkit-keyframes translate {
  from{
      transform: translate(-100%);
  }
  to{
      transform: translate(100%);
  }
}

</style>
